import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'
import ICU from 'i18next-icu'

i18n
  .use(ICU) // ICU MessageFormat support
  .use(HttpBackend) // Load translations from JSON files
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Bind i18next to react-i18next
  .init({
    fallbackLng: localStorage.getItem('language') || 'en', // Use persisted language
    supportedLngs: ['en', 'nl', 'fr', 'es'], // Define supported languages
    debug: true,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'cookie', 'navigator'],
      caches: ['localStorage', 'cookie'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json', // JSON translation files
    },
  })

export default i18n
